<template>
    <button @click="toggleChatWindowStatus(type)" 
            :title="$gettext('Seleccionar tema: ') + type.text"
            tabindex="0"
            :url="url"
            class="typeChat">
        {{ type.text }}
    </button>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/event-bus';

export default {
    name: 'TypeChat',
    props: ['type', "index", "url"],
    computed: {
        ...mapState(['chatType', 'operators', 'chatTypes', 'chatWindowStatus', 'waitingList', 'groupsWithCamera', 'isChatAvailable', 'language']),
    },
    methods: {
        ...mapMutations(['changeChatWindowStatus', 'emptyChatWindow', 'setChatType']),
        /**
         * Enriches the generic blocked message with the group's contact email when available.
         * Falls back to a plain "access not permitted" message if no email is configured.
         */
        setBlockedWithGroupEmail() {
            const email = this.type && this.type.email;
            const base = 'Acceso no permitido.';
            const msg = email
                ? `${base} Por favor, contacta con nosotros en ${email}`
                : base;
            this.$store.commit('setAccessBlockedMessage', msg);
        },
        async toggleChatWindowStatus(value) {
            // Handle appointment redirects
            if (value.url) {
                const url = value.url;
                window.location.href = `/${url}`;
                return;
            }

            // Clear any previous blocked-access banner before starting a new chat attempt.
            this.$store.commit('setAccessBlockedMessage', null);
            this.$store.commit('setContactPhone', value.contact_phone);
            this.$store.commit('setOpeningHours', value.opening_hour);
            this.$store.commit('setClosingHours', value.closing_hour);

            if (this.groupsWithCamera.includes(this.type.id)) {
                this.$store.commit('setSelectedGroupGotCamera', true);
            } else {
                this.$store.commit('setSelectedGroupGotCamera', false);
            }
            if (value.choose_operator) {
                EventBus.$emit('operatorsListed');
                await this.$store.http.checkForOperators(this.type.id);
                await this.setChatType(this.index);

                // Backend returned 403 during operator check — show group-specific error and abort.
                if (this.$store.state.accessBlockedMessage) {
                    this.setBlockedWithGroupEmail();
                    return;
                }
                if (this.operators.length === 0 || this.isChatAvailable === false) {
                    this.changeChatWindowStatus(4);
                } else {
                    this.changeChatWindowStatus(5);
                }
            } else {
                await this.$store.http.createThread(value.id, this.index);
                // Backend returned 403 during thread creation — show group-specific error.
                if (this.$store.state.accessBlockedMessage) {
                    this.setBlockedWithGroupEmail();
                }
            }
        },

        translateText(text) {
            switch (true) {
                case text.includes('Information'):
                    return this.$gettext('Information');
                case text.includes('buy'):
                    return this.$gettext('I want to buy');
                case text.includes('Purchases'):
                    return this.$gettext('PWS Purchases');
                case text.includes('transporte'):
                    return this.$gettext('Toma de transporte, montaje y medida');
                case text.includes('Pruebas'):
                    return this.$gettext('Tests');
                default:
                    return text;
            }
        }
    },
}
</script>